export const XSRF_HEADER_NAME = 'x-xsrf-token';

export type TokenDTO = 'x-xsrf-token' | 'XSRF-TOKEN';

export const TOKEN_NAMES = {
  DEFAULT: 'x-xsrf-token',
  CONSUMER_BENEFIT: 'XSRF-TOKEN',
};
export const tokens = new Map();

export const setXsrfToken = (response: Response, tokenName: TokenDTO = XSRF_HEADER_NAME) => {
  const tokenHeader = response.headers.get(XSRF_HEADER_NAME);
  if (tokenHeader) {
    // Split the header by comma in case of multiple tokens
    const tokensArray = tokenHeader.split(',')?.map((token: string) => token.trim());
    const uniqueToken = [...new Set(tokensArray)][0];
    if (uniqueToken) {
      tokens.set(tokenName, uniqueToken);
    }
  }
};

export const getXsrfTokenHeader = (tokenName: TokenDTO = XSRF_HEADER_NAME): Headers => {
  const token = tokens.get(tokenName);
  return token ? new Headers({ [XSRF_HEADER_NAME]: token }) : new Headers();
};

export const resetToken = () => {
  tokens.clear();
};
